import React from 'react'; 
import Header from './Header';
import About from './About';
import Project from './Project';
import Hire from './Hire-me';
import Contact from './Contact';
import Service from './Service';
import Education from './Education';
import TechStack from './TechStack';

function Home() {

    return (
        <>
            <Header />
            <About />
            <Service />
            <Project />
            <Education />
            <TechStack />
            <Hire />
            <Contact />
        </>
    );

    }

export default Home;
